import {
  observable,
  action,
  computed,
  reaction,
  toJS
} from 'mobx';
import {
  ViewBase,
  Action,
  Expression
} from 'mutants-appfx';
import _get from 'lodash/get';
import _set from 'lodash/set';

class DetailTab {
  @observable sortBy;
  @observable mergesBy = [];
  @observable addBy;
  @observable selectIndexs = [];
  @observable checkEnabled;
  @observable clickType; // update or copy
  @observable title;

  @observable columns = [];
  @observable data = [];

  @observable currentIndex;

  @observable info;
  @observable ok = true;
  @observable cancel = true;

  @computed get currentRow() {
    return this.data[this.currentIndex];
  }

  @action setCurrent(index) {
    this.currentIndex = index;
  }

  constructor(columns) {
    this.columns = columns || [];
    reaction(() => toJS(this.data), () => {
      const mergeData = this.data.reduce((rows, it) => {
        const row = rows.find(e => this.mergesBy.every(key => _get(e, key) === _get(it, key)));
        if (!row) {
          rows.push({ ...it });
        } else if (this.addBy) {
          _set(row, this.addBy, _get(row, this.addBy) + _get(it, this.addBy));
        }
        return rows;
      }, []);
      if (mergeData.length !== this.data.length) {
        this.data = mergeData;
      }
    });
  }

  @computed get selecteds() {
    return this.selectIndexs.map(i => this.data[i]);
  }

  @computed get rows() {
    return this.data.reduce((rows, it, i) => {
      // const row = rows.find(e => this.mergesBy.every(key => _get(e, key) === _get(it, key)));
      // if (!row) {
      rows.push({
        ...toJS(it),
        key: i,
        _checked: this.selectIndexs.indexOf(i) > -1
      });
      // } else if (this.addBy) {
      //   _set(row, this.addBy, _get(row, this.addBy) + _get(it, this.addBy));
      // }
      return rows;
    }, []).sort((a, b) => _get(a, this.sortBy) - _get(b, this.sortBy));
  }

  @action setColumns(title, columns, merges, addField, sortBy, clickType) {
    this.title = title;
    this.mergesBy = merges;
    this.addBy = addField;
    this.columns = (columns || []);
    this.sortBy = sortBy;
    this.clickType = clickType;
  }

  @action mergeColumns(columns) {
    this.columns.push(...(columns.filter(it => !this.columns.some(e => e.key === it.key))));
  }

  @action load(data) {
    this.data = data || [];
  }

  @action setInfo(info, ok, cancel) {
    this.info = info;
    this.ok = ok;
    this.cancel = cancel;
  }

  @action mergeRows(i) {
    // 合并重复行
    const row = this.data[i];
    const detailKey = this.getDetailKey(row);
    const rows = this.data.filter(e => this.getDetailKey(e) === detailKey);

    if (rows.length > 1) {
      for (let i = 1; i < rows.length; i++) {
        const remRow = rows[i];
        this.data.splice(this.data.indexOf(remRow), 1);
        if (this.addBy == 'Quantity') {
          _set(rows[0], this.addBy, parseInt(_get(rows[0], this.addBy)) + parseInt(_get(remRow, this.addBy)));
        }
        else {
          _set(rows[0], this.addBy, _get(rows[0], this.addBy) + _get(remRow, this.addBy));
        }

      }
    }
    this.currentIndex = this.data.indexOf(rows[0]);
  }

  @action mergeByRow(row) {

  }

  @action getDetailKey(detail) {
    let returnKey = "";
    for (let index = 0; index < this.mergesBy.length; index++) {
      let value = "";
      if (_get(detail, this.mergesBy[index])) {
        value = _get(detail, this.mergesBy[index]);
      }
      if (value && (this.mergesBy[index] == 'ProductionDate' || this.mergesBy[index] == 'ExpiryDate')) {
        let date = value;
        if (typeof (value) == "string") {
          date = new Date(value);
        }
        if (date > new Date(Date.parse('1900-01-01'))) {
          value = date.toLocaleDateString();
        }
        else {
          value = "";
        }
      }
      returnKey = returnKey + "|" + this.mergesBy[index] + "=" + value;
    }
    return returnKey;
  }

  @action updateRow(i, raw) {
    Object.keys(raw).forEach(key => {
      //if (key in this.data[i]) {
      this.data[i][key] = raw[key];
      //}
    });
    //this.currentIndex = this.rows.findIndex(item=> item.key == i)

    // this.data.forEach((item, index) => {
    //   console.log(item,index, '00000000')
    //   if (item.key === i){
    //     this.currentIndex = index
    //   }
    // })
    //this.currentIndex = i;
    this.mergeRows(i);
  }

  @action copyRow(i) {
    // const row = this.data[i];
    // if (row[this.addBy] > 0) {
    //   row[this.addBy] = 1;
    //   this.data.push(row);
    // }
  }

  @action addRow(row) {
    // this.data.push(row);
    // this.currentIndex = this.data.length - 1;
    // this.mergeRows(this.data.length - 1);
    //合并重复行
    const detailKey = this.getDetailKey(row);
    const rows = this.data.filter(e => this.getDetailKey(e) === detailKey);
    if (rows.length > 0) {
      _set(rows[0], this.addBy, parseInt(_get(rows[0], this.addBy)) + parseInt(_get(row, this.addBy)));
      this.currentIndex = this.data.indexOf(rows[0]);
    }
    else {
      this.data.push(row);
      this.currentIndex = this.data.length - 1;
    }
  }

  @action deleteRow(row) {
    this.data.splice(this.data.indexOf(row), 1);
    this.currentIndex = this.data.length - 1;
  }

  @action showCheckBox(enabled = true) {
    this.checkEnabled = enabled;
  }

  @action select(index, checked) {
    if (checked) {
      if (this.selectIndexs.indexOf(index) === -1) {
        this.selectIndexs.push(index);
      }
    } else {
      this.selectIndexs.splice(this.selectIndexs.indexOf(index), 1);
    }
  }

  @action selectAll() {
    this.selectIndexs.push(...this.rows.map((d, i) => i).filter(index => this.selectIndexs.indexOf(index) === -1));
  }
}

// 相关明细：赠品、打折商品
class PlanDetail {
  @observable title;
  // 明细数据是否显示编辑
  @observable visible;
  @observable reason;

  @observable extraMessage;
  @observable tabs = [];
  @observable activeTabIndex = 0;

  @observable selectorResult;
  @observable visibleSelector;
  @observable columns = [];
  @observable data = [];
  @observable selectIndex = -1;
  @observable titleSelector;


  @computed get activeTab() {
    return this.tabs[this.activeTabIndex] || this.tabs[0];
  }

  @computed get selectRow() {
    if (this.selectIndex === -1 || this.data.length <= 0) {
      return null;
    }
    return this.data[this.selectIndex] || null;
  }

  constructor(tabs) {
    this.tabs = tabs;
  }


  @action showSelector(title, columns, data) {
    this.titleSelector = title;
    this.columns = columns;
    this.data = data;
    this.visibleSelector = true;
  }

  @action select(index) {
    this.selectIndex = index;
  }

  @action hideSelector(reason) {
    this.selectorResult = reason;
    this.visibleSelector = false;
  }

  @action setActiveTab(index) {
    this.activeTabIndex = index;
  }

  @action createTabs(count = 1) {
    this.tabs.clear();
    for (let i = 0; i < count; i++) {
      this.tabs.push(new DetailTab());
    }
  }

  @action show(title, extraMessage) {
    this.title = title;
    this.visible = true;
    this.reason = null;
    this.extraMessage = extraMessage;
  }

  @action hide(reason = 'ok') {
    this.reason = reason;
    this.visible = false;
  }

  @action clear() {
    this.data.length = 0;
  }

  static fromJS(objs = [{}]) {
    const tabs = objs.map(({
      columns,
      rows
    }) => {
      const tab = new DetailTab(columns || []);
      if (rows) {
        tab.load(rows);
      }
      return tab;
    })
    const data = new PlanDetail(tabs);
    return data;
  }
}

// 方案项
class PlanItem {
  planList;
  key;
  @observable title;
  @observable description;
  @observable extra;
  @observable tabs;

  // 方案是否显示
  @observable visible;

  constructor(planList, key, title, description, extra) {
    this.planList = planList;
    this.key = key;
    this.title = title;
    this.description = description;
    this.extra = extra;
    this.visible = true;
  }

  @action remove() {
    this.planList.selectedDetails.splice(this.planList.selectedKeys.indexOf(this.key), 1);
    this.planList.selectedKeys.splice(this.planList.selectedKeys.indexOf(this.key), 1);
  }

  static fromJS(planList, obj) {
    return new PlanItem(planList, obj.key, obj.title, obj.description, obj.extra);
  }

  toString() {
    return this.title;
  }
}

// 方案列表，提供促销等方案选择
export default class PlanListModel extends ViewBase {
  get type() {
    return 'PlanListModel';
  }

  @observable visible;
  @observable title;
  @observable isLoading;
  @observable result;
  @observable loadMapping;
  @observable detailEditor = observable.map();

  @observable extraLabel;
  @observable placeholder;

  // 所有方案项
  @observable items = [];
  // 选中方案，有顺序
  @observable selectedKeys = [];
  // 相关明细数据
  @observable selectedDetails = [];


  @observable moreBtns = [];

  // 方案加载
  @observable onLoad;
  // 方案选择事件
  @observable onSelected;
  @observable onDetailOk;
  @observable onDetailCancel;
  // 数据改变后事件
  @observable onDetailChange;
  @observable onSearch;
  // 取消所有方案事件
  @observable onCancel;
  @observable onOk;

  @observable onSelectOk;
  @observable onSelectCancel;

  @observable onRowClick;
  @observable onMoreClick;

  @computed get selecteds() {
    return this.selectedKeys.map(key => this.items.find(it => key === it.key));
  }

  // 待选方案项
  @computed get waitingItems() {
    return this.items.filter(it => it.visible);
  }

  // 当前有效的方案
  @computed get activeItem() {
    if (this.selecteds.length <= 0) {
      return null;
    }
    return this.selecteds[this.selecteds.length - 1];
  }

  @computed get activeDetail() {
    if (this.selecteds.length <= 0) {
      return null;
    }
    return this.selectedDetails[this.selecteds.length - 1];
  }

  constructor(store, name, title, loadMapping,
    extraLabel, placeholder, editor,
    onLoad, onSelected, onDetailOk,
    onDetailCancel,
    onDetailChange, onSearch,
    onCancel, onOk,
    onRowClick, onMoreClick) {
    super(store, name);
    this.title = title;
    this.onLoad = onLoad;
    this.extraLabel = extraLabel;
    this.placeholder = placeholder;
    this.loadMapping = loadMapping;
    Object.keys(editor || {}).forEach(key => {
      this.detailEditor.set(key, editor[key]);
    });
    this.onSelected = onSelected;
    this.onDetailOk = onDetailOk;
    this.onDetailChange = onDetailChange;
    this.onDetailCancel = onDetailCancel;
    this.onCancel = onCancel;
    this.onSearch = onSearch;
    this.onOk = onOk;
    this.onRowClick = onRowClick;
    this.onMoreClick = onMoreClick;
  }


  @action addMoreButtons(name, text) {
    this.moreBtns.push({ name: text, action: name, visible: false });
  }

  @action setBtnVisible(name, visible) {
    const btn = this.moreBtns.find(it => it.action === name);
    btn.visible = visible;
  }

  @action show() {
    this.visible = true;
  }

  @action hide(result) {
    this.result = result;
    this.visible = false;
  }

  // 加载方案
  @action load(planItems) {
    this.clear();
    this.items.length = 0;
    let mapping;
    if (this.loadMapping) {
      mapping = new Expression(this.loadMapping);
    }
    this.items.push(...planItems.map(it => PlanItem.fromJS(this, mapping ? mapping.exec(it) : it)));
  }

  @action setVisible(items) {
    this.items.forEach(it => {
      it.visible = items.some(sit => sit === it.key)
    });
  }

  // 选中方案
  @action select(key) {
    this.selectedKeys.push(key);
    const detail = PlanDetail.fromJS();
    this.selectedDetails.push(detail);
  }

  // 清空选中方案
  @action clear() {
    this.selectedKeys.length = 0;
    this.selectedDetails.length = 0;
    this.items.forEach(it => it.visible = true);
  }

  static fromJS(store, {
    planInfo = {}
  }) {
    return new PlanListModel(store, planInfo.name,
      planInfo.title,
      planInfo.loadMapping,
      planInfo.extraLabel,
      planInfo.placeholder,
      planInfo.editor,
      Action.fromJS(store, planInfo.onLoad),
      Action.fromJS(store, planInfo.onSelected),
      Action.fromJS(store, planInfo.onDetailOk),
      Action.fromJS(store, planInfo.onDetailCancel),
      Action.fromJS(store, planInfo.onDetailChange),
      Action.fromJS(store, planInfo.onSearch),
      Action.fromJS(store, planInfo.onCancel),
      Action.fromJS(store, planInfo.onOk),
      Action.fromJS(store, planInfo.onRowClick),
      Action.fromJS(store, planInfo.onMoreClick)
    );
  }
}
